import Icon from '../components/Icon.vue'

Icon.register({
  'volume-up': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M215 71.1L126.1 160H24C10.7 160 0 170.7 0 184V328C0 341.3 10.7 352 24 352H126.1L215 440.9C230.1 456 256 445.4 256 424V88C256 66.6 230 56 215 71.1zM448.4 20C437.2 12.6 422.2 15.7 414.8 26.9 407.5 38.1 410.6 53.1 421.8 60.4 488.1 103.9 527.6 177 527.6 256 527.6 335 488.1 408.1 421.8 451.6 410.6 458.9 407.5 473.9 414.8 485.1 421.9 495.8 436.8 499.6 448.4 492 528.3 439.6 576 351.3 576 256S528.3 72.4 448.4 20zM480 256C480 192.5 447.9 134.1 394.2 99.8 383 92.6 368.2 95.9 361.1 107.2S357.3 133.4 368.5 140.6C408.3 166 432 209.1 432 256S408.3 346 368.5 371.4C357.3 378.6 354 393.5 361.1 404.8 367.6 415.1 382.2 419.9 394.2 412.2 447.9 377.9 480 319.5 480 256zM338.2 179.1C326.7 172.8 312 177 305.6 188.6 299.2 200.2 303.5 214.8 315.1 221.2 328 228.3 336 241.6 336 256 336 270.4 328 283.7 315.1 290.8 303.5 297.2 299.2 311.8 305.6 323.4 312.1 335.1 326.7 339.2 338.2 332.9 366.5 317.3 384 287.9 384 256S366.5 194.7 338.2 179.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-up.js
// module id = vXMS
// module chunks = 144